import React from 'react';
export function Features() {
  const features = [{
    icon: '📏',
    title: 'Instrucciones Gramo a Gramo',
    description: 'Cada receta tiene el desglose exacto de ingredientes. Sin adivinar, sin "a ojo". La barrita sale perfecta la primera vez.'
  }, {
    icon: '💰',
    title: 'Precios de Mayorista Incluidos',
    description: 'Sabés exactamente dónde comprar en Argentina para pagar centavos por gramo de proteína. Costo real: menos de $800 por barrita.'
  }, {
    icon: '🍫',
    title: '50+ Recetas para Todos los Niveles',
    description: 'Sin horno, veganas, para freezar, para vender. Una colección completa que cubre desde el principiante total hasta el atleta avanzado.'
  }];
  return <section className="bg-white py-20 px-5 border-t border-b border-[#E2E8F0]" data-id="element-30">
      <div className="max-w-[780px] mx-auto" data-id="element-31">
        <div className="w-12 h-1 bg-gradient-to-r from-[#15803D] to-[#22C55E] rounded-sm mx-auto mb-5" data-id="element-32" />

        <h2 className="font-montserrat text-[clamp(22px,3.5vw,32px)] font-extrabold text-center mb-[10px] text-[#0F172A] tracking-tight leading-[1.2]" data-id="element-33">
          ¿Por qué es 10x mejor que todo lo que encontrás en internet?
        </h2>

        <p className="text-center text-[#475569] text-[15px] mb-10" data-id="element-34">
          3 ventajas que no vas a encontrar en ningún otro lado
        </p>

        <div className="grid grid-cols-[repeat(auto-fit,minmax(210px,1fr))] gap-5 max-w-[740px] mx-auto" data-id="element-35">
          {features.map((feat, idx) => <div key={idx} className="bg-white border-[1.5px] border-[#E2E8F0] rounded-[14px] p-8 px-6 text-center transition-all duration-[0.25s] relative overflow-hidden hover:-translate-y-1.5 hover:shadow-[0_16px_40px_rgba(15,23,42,0.12)] hover:border-[#22C55E] after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[3px] after:bg-gradient-to-r after:from-[#22C55E] after:to-[#F97316] after:scale-x-0 after:transition-transform after:duration-[0.25s] after:origin-left hover:after:scale-x-100" data-id="element-36">
              <span className="text-4xl mb-4 block" data-id="element-37">{feat.icon}</span>
              <h3 className="font-montserrat text-base font-bold mb-[10px] text-[#0F172A]" data-id="element-38">
                {feat.title}
              </h3>
              <p className="text-sm text-[#475569] leading-[1.65]" data-id="element-39">
                {feat.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}